import house1 from "../media/image1.png";
import house2 from "../media/image2.png";
import house3 from "../media/image3.png";

const properties = [
    {
        id: "1",
        img: house1,
        price: "35000",
        address: "Ultra Halli, Bengaluru 61",
        bedrooms: 2,
        bathrooms: 2,
        space: 2000,
    },

    {
        id: "2",
        img: house2,
        price: "38000",
        address: "Ultra Halli, Bengaluru 61",
        bedrooms: 3,
        bathrooms: 2,
        space: 2300,
    },

    {
        id: "3",
        img: house3,
        price: "47000",
        address: "Ultra Halli, Bengaluru 61",
        bedrooms: 69,
        bathrooms: 3,
        space: 3000,
    },
];


export default properties